import PropTypes from 'prop-types';

import { Layout, MinusPlusButtons } from '@utilities';

import styles from './_index.module.scss';

const MAX_OPTIONS_PER_SET = 6;
const MIN_OPTIONS_PER_SET = 3;

const OptionsPerSet = ({ question, setOptionsPerSet }) => {
  const optionsPerSet = question.properties.optionsPerSet;

  return (
    <Layout.Flex gap="small">
      Attributes per set:
      <Layout.Flex className={styles['options-per-set']} gap="x-small">
        <strong>{optionsPerSet}</strong>
        <MinusPlusButtons
          disableMinusButton={optionsPerSet <= MIN_OPTIONS_PER_SET}
          disablePlusButton={optionsPerSet >= MAX_OPTIONS_PER_SET}
          isNeutral
          onClickMinus={() => {
            setOptionsPerSet(Math.max(MIN_OPTIONS_PER_SET, optionsPerSet - 1));
          }}
          onClickPlus={() => {
            setOptionsPerSet(Math.min(MAX_OPTIONS_PER_SET, optionsPerSet + 1));
          }}
        />
      </Layout.Flex>
    </Layout.Flex>
  );
};

OptionsPerSet.propTypes = {
  question: PropTypes.object.isRequired,
  setOptionsPerSet: PropTypes.func.isRequired,
};

export default OptionsPerSet;
